import { memo } from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { UseFormReturn, Controller } from 'react-hook-form';

import { FormItem } from 'components/shared';
import { TextFieldElement } from 'components/muiInputWrappers';
import { validationRules } from 'helpers/utils';

function ShortAnswer({
  form,
  id,
  isEditable = true,
  isReadOnly,
  itemFull
}: {
  isReadOnly?: boolean;
  id: string;
  form: UseFormReturn;
  isEditable?: boolean;
  itemFull?: { idSurveyQuestion: string; isRequired: boolean };
}) {
  const { t } = useTranslation('global');
  const { validateSpaces } = validationRules();

  return (
    <FormItem style={{ width: '100%' }}>
      {isEditable ? (
        <>
          {/* Campo oculto para idSurveyQuestion */}
          <Controller
            control={form.control}
            defaultValue={itemFull?.idSurveyQuestion || ''}
            name={`${id}-idSurveyQuestion`} // Registra idSurveyQuestion en el formulario
            render={({ field }) => (
              <input
                type="hidden"
                {...field}
                value={itemFull?.idSurveyQuestion}
              />
            )}
          />

          <TextFieldElement
            control={form.control}
            disabled={isReadOnly}
            inputProps={{
              type: 'text'
            }}
            name={`${id}-shortAnswer`} // Nombre único para cada respuesta corta
            placeholder={
              isReadOnly
                ? t('survey.messages.text100')
                : t('survey.messages.enterAnswer')
            }
            required={isReadOnly ? false : itemFull?.isRequired} // Requiere si no es de solo lectura y es obligatorio
            size="small"
            validation={{
              maxLength: {
                value: 100,
                message: t('survey.messages.valueLonger', { number: '100' })
              },
              required: {
                value: isReadOnly ? false : itemFull?.isRequired,
                message: t('common.commonMessages.requiredField', {
                  field: `${id}-shortAnswer`
                })
              },
              validate: validateSpaces
            }}
            variant={isReadOnly ? 'filled' : 'outlined'}
            fullWidth
          />
        </>
      ) : (
        <Typography variant="body1">
          {form.getValues(`${id}-shortAnswer`)}
        </Typography>
      )}
    </FormItem>
  );
}

export default memo(ShortAnswer);
